function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
import Presentation from "./Presentation";
var ForgotPassword = function(props) {
    return /*#__PURE__*/ React.createElement(Presentation, _extends({}, props));
};
export default ForgotPassword;
